import { View } from 'react-native';
import { Color, Padding } from '@/GlobalStyles';

const MenuDivider = () => {
  return <View style={styles.divider} />;
};

export default MenuDivider;

const styles = {
  divider: {
    height: 1,
    width: '100%',
    backgroundColor: Color.colorGray_200,
    marginVertical: Padding.p_smi,
  },
};
